import tinycolor from 'tinycolor2';
import { WCAG_AA_RATIO } from './wcag';

const LIGHT_FOREGROUND = 'hsl(0, 0%, 100%)';
const DARK_FOREGROUND = 'hsl(220, 20%, 12%)';

export const getContrastTextColor = (color: string): string => {
  const base = tinycolor(color);
  if (!base.isValid()) {
    return LIGHT_FOREGROUND;
  }

  const lightContrast = tinycolor.readability(base, LIGHT_FOREGROUND);
  const darkContrast = tinycolor.readability(base, DARK_FOREGROUND);

  if (lightContrast >= WCAG_AA_RATIO) {
    return LIGHT_FOREGROUND;
  }
  if (darkContrast >= WCAG_AA_RATIO) {
    return DARK_FOREGROUND;
  }
  return lightContrast > darkContrast ? LIGHT_FOREGROUND : DARK_FOREGROUND;
};
